import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    user: {},
    role: '',
    roleList: [],
    currentId: '',
    pageList: [],
    selectList: [],
    allPage: [],
    addBaseData: {},
    permissions: []
  },
  getters: {
    getToken: (state) => {
      return state.token
    },
    getUser: (state) => {
      return state.user
    },
    getRole: (state) => {
      return state.role
    },
    getRoleList: (state) => {
      return state.roleList
    },
    getSelectList: (state) => {
      return state.selectList
    },
    permissions: (state) => {
      return state.permissions
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setCurrentId(state, currentId) {
      state.currentId = currentId
      localStorage.setItem('current', state.currentId)
    },
    setPageList(state, pageList) {
      state.pageList = pageList
    },
    setAllpage(state, allPage) {
      state.allPage = allPage
    },
    setSelectList(state, selectList) {
      state.selectList = selectList
    },
    clearToken(state) {
      state.token = ''
      localStorage.removeItem('token')
    },
    setUser(state, user) {
      state.user = user
      if (user.role) {
        const roleData = user.role.filter((item) => item.roleName === state.role)[0]
        if (!roleData) {
          state.role = user.role[0].roleName
          state.permissions = user.role[0].permissions
        } else {
          state.permissions = roleData.permissions
        }
        state.roleList = user.role || []
      }
      localStorage.setItem('user', user)
    },
    deleteUser(state) {
      state.user = {}
      state.currentId = ''
      state.role = ''
      state.roleList = []
      localStorage.removeItem('user')
    },
    setRole(state, role) {
      state.role = role
    }
  },
  actions: {
    updateToken({ commit }, token) {
      commit('setToken', token)
    },
    updateUser({ commit }, user) {
      commit('setUser', user)
    },
    updatePageList({ commit }, pageList) {
      commit('setPageList', pageList)
    },
    updateSelectList({ commit }, selectList) {
      commit('setSelectList', selectList)
    },
    updateSetAllpage({ commit }, allPage) {
      commit('setAllpage', allPage)
    }
  },
  modules: {},
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      key: 'store',
      reducer(state) {
        return {
          token: state.token,
          permissions: state.permissions,
          currentId: state.currentId,
          pageList: state.pageList,
          role: state.role
        }
      }
    })
  ]
})
